import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Card, FormSelect } from 'react-bootstrap'
import Select from "react-select"
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate, addCandidateWork, deleteCandidateWork, getCandidateProfileStatus } from '../../actions/candidatesActions'
import Swal from 'sweetalert2'
import { getProfileTypes } from '../../actions/profileTypesActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { getAllSubjects, getLevels } from '../../actions/miscellaneousActions'

export default function CareerPath() {
    const {id: candidateId} = useParams() || {}
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [submitButton, setSubmitButton] = useState('submit');


    const {candidate, resultcandidate} = useSelector(state=>state.candidates)
    const {subjects, levels} = useSelector(state => state.miscellaneous)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getCandidate(candidateId || client?.id))
            dispatch(getProfileTypes())
            dispatch(getAllSubjects())
            dispatch(getLevels())
        }
    },[dispatch, t, client])

    const [newProfessionalCompanyType, setNewProfessionalCompanyType] = useState({
        options: [
            {label: t('profile.candidate.academy'), value: 'academy'},
            {label: t('profile.candidate.kindergarten'), value: 'kindergarten'},
            {label: t('profile.candidate.school'), value: 'School'},
            {label: t('profile.candidate.universityCompany'), value: 'university'}
        ],
        selected: null
    })

    const [newProfessionalTaughtSubjects, setNewProfessionalTaughtSubjects] = useState([])
    const [newProfessionalTaughtLevels, setNewProfessionalTaughtLevels] = useState([])

    const [formStateNewProfessional, setFormStateNewProfessional] = useState({
		work: '',
		description: '',
		start_date: '',
		end_date: '',
        companyName: '',
        country: '',
        province: '',
        town: '',
        stillWorking: false,
        contractType: null,
        unexperienced: false
    })

    const [provinceAux, setProvinceAux] = useState({label: '', value: ''});
    const [townAux, setTownAux] = useState({label: '', value: ''});
    const [townsAux, setTownsAux] = useState([]);

    const handleInputNewProfessional = ({target})=>{
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            [target.name]: target.value,
            unexperienced: false
        })
    }

    const handleSelectNewProfessionalCompany = (target) => {
        setNewProfessionalCompanyType({
            ...newProfessionalCompanyType,
            selected: target
        })
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            unexperienced: false
        })
    }

    const handleSelectNewProfessionaltaughtSubjects = (values) => {
        setNewProfessionalTaughtSubjects(values)
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            unexperienced: false
        })
    }

    const handleSelectNewProfessionaltaughtLevels = (values) => {
        setNewProfessionalTaughtLevels(values)
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            unexperienced: false
        })
    }

    const handleAddProfessional = async(e) => {
        e.preventDefault()
 
        if(formStateNewProfessional.unexperienced || (!formStateNewProfessional.unexperienced && newProfessionalCompanyType?.selected?.value)){
            let taughtSubjectsArr = []
            let taughtLevelsArr = []
            
            for await(const subject of newProfessionalTaughtSubjects) {
                taughtSubjectsArr.push(subject.value)
            }
            for await(const level of newProfessionalTaughtLevels) {
                taughtLevelsArr.push(level.value)
            }
            dispatch(addCandidateWork(newProfessionalCompanyType.selected?.value, {...formStateNewProfessional, taughtSubjects: taughtSubjectsArr, taughtLevels: taughtLevelsArr}, candidateId || client?.id))
            setNewProfessionalTaughtSubjects([])
            setNewProfessionalTaughtLevels([])
            setNewProfessionalCompanyType({...newProfessionalCompanyType, selected: null})
            setFormStateNewProfessional({
                work: '',
                description: '',
                start_date: '',
                end_date: '',
                companyName: '',
                country: '',
                province: '',
                town: '',
                stillWorking: false,
                contractType: null,
                unexperienced: false
            })
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'error',
                text: t('profile.candidate.thereIsNotCompanyType')
            })
        }
    }

    const handleDeleteProfessional = async(e, work) => {
        e.preventDefault()
 
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text: t('profile.candidate.areyousuredelete')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteCandidateWork(work, candidateId || client?.id))
            }
        })
    }

    const handleSelectProvinceChange = (target)=>{
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            'province': target.value,
            'town': ''
        })
        setProvinceAux(provinces.filter(province => province.value === target.value))
        setTownAux({label: '', value: ''})
        setTownsAux(towns.filter(town => town.parent_value === target.value))
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            unexperienced: false
        })
    }

    const handleSelectTownChange = (target)=>{
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            'town': target.value
        })
        setTownAux(towns.filter(town => town.value === target.value && target.parent_value === town.parent_value))
        setFormStateNewProfessional({
            ...formStateNewProfessional,
            unexperienced: false
        })
    }

    useEffect(() => {
        if (candidate) {
            setFormStateNewProfessional({...formStateNewProfessional, unexperienced: candidate.unexperienced === null || candidate.unexperienced === undefined ? false : candidate.unexperienced})
        }
    // eslint-disable-next-line
    }, [candidate])

    useEffect(() => {
        if(resultcandidate){
            switch (resultcandidate) {
                case 'successaddprofessional':
                    dispatch(getCandidate(candidateId || client?.id))
                    if(submitButton==='submit'){
                        Swal.fire({
                            showConfirmButton: true,
                            showDenyButton: false,
                            confirmButtonText: t('global.great'),
                            icon: 'success',
                            text: t('profile.candidate.successaddprofessional')
                        })
                    }else{
                        if(candidateId){
                            navigate('/candidate/competences/'+candidateId)
                        }else{
                            navigate('/candidate/profile/competences')
                        }
                    }
                    dispatch(getCandidateProfileStatus(candidateId || client?.id))
                    break;
                case 'erroraddprofessional':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('profile.candidate.erroraddprofessional')
                    })
                    break;
                case 'successdeleteprofessional':
                    dispatch(getCandidate(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('profile.candidate.successdeleteprofessional')
                    })
                    dispatch(getCandidateProfileStatus(candidateId || client?.id))
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultcandidate])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-4'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/experienciabig.svg" alt="Icono Experiencia" />
                        <h1 className='ms-2 m-0'>{t('menus.professional')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
                                <Row className="mb-3">
                                    <Col>
                                        <h3>{t('profile.candidate.professional')}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    {candidate?.professional?.length > 0
                                        ?
                                            candidate?.professional?.map((work, key) => (
                                                <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center' key={key}>
                                                    <div className='d-flex'>
                                                        <div className='me-5'><i className='fas fa-briefcase fa-3x' /></div>
                                                        <div>
                                                            <h4>
                                                                {work.work} | 
                                                                <span className='ps-2'>
                                                                    {work.start_date ? work.start_date?.substr(8,2)+'/'+work.start_date?.substr(5,2)+'/'+work.start_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                                    &nbsp;-&nbsp;
                                                                    {work.end_date ? work.end_date?.substr(8,2)+'/'+work.end_date?.substr(5,2)+'/'+work.end_date?.substr(0,4) : work.start_date ? t('profile.candidate.upToday') : t('profile.candidate.nodate')}
                                                                </span>
                                                            </h4>
                                                            {
                                                            work.taughtSubjects.map((subject, key) => (
                                                                <>
                                                                    {key > 0 ? '|' : ''}
                                                                    <small key={key} className='mx-1'>
                                                                        {t('profile.candidate.subjects.'+subject)}
                                                                    </small>
                                                                </>
                                                            ))
                                                            }
                                                            <br/>
                                                            {work.companyName} {work.contractType && (t('profile.candidate.'+work.contractType))}
                                                            <br/>
                                                            <small>{work.description}</small>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <img src="/images/trash.svg" className='cursor' alt="Trash" onClick={e => handleDeleteProfessional(e, work._id)} />
                                                    </div>
                                                </Col>
                                            ))

                                        :
                                            <></>
                                    }
                                </Row>
                                <Row className="mt-1 mb-3">
                                    <Col className="justify-content-center">
                                        <Form onSubmit={handleAddProfessional}>
                                            <Row>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='company_type'>{t('profile.candidate.company_type')}</Form.Label>
                                                    <Select
                                                        className="select"
                                                        onChange={handleSelectNewProfessionalCompany}
                                                        name="company_type"
                                                        options={newProfessionalCompanyType.options}
                                                        value={newProfessionalCompanyType.selected}
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                </Col>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='work'>{t('profile.candidate.position')}</Form.Label>
                                                    <Form.Control
                                                        type='text'
                                                        name='work' 
                                                        value={formStateNewProfessional.work ||  ''}
                                                        onChange={handleInputNewProfessional}
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='companyname'>{t('profile.candidate.companyname')}</Form.Label>
                                                    <Form.Control
                                                        type='text'
                                                        name='companyName'
                                                        value={formStateNewProfessional.companyName ||  ''}
                                                        onChange={handleInputNewProfessional}
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                </Col>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='country'>{t('profile.candidate.country')}</Form.Label>
                                                    <Form.Control
                                                        type='text'
                                                        name='country'
                                                        value={formStateNewProfessional.country ||  ''}
                                                        placeholder={t('profile.candidate.country')}
                                                        onChange={handleInputNewProfessional}
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='province'>{t('profile.candidate.province')}</Form.Label>
                                                    <Select
                                                        className="select" 
                                                        name='province'
                                                        options={provinces.sort((a, b) => {
                                                            if (a.label < b.label) {
                                                                return -1
                                                            }
                                                            if (a.label > b.label) {
                                                                return 1
                                                            }
                                                            return 0
                                                        })}
                                                        value={provinceAux || null}
                                                        onChange={(e) => handleSelectProvinceChange(e)}
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                    <input
                                                        tabIndex={-1}
                                                        autoComplete="off"
                                                        style={{ opacity: 0, height: 0 }}
                                                        value={formStateNewProfessional.province || ''}
                                                        required={!formStateNewProfessional.unexperienced}
                                                        readOnly
                                                    />
                                                </Col>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='town'>{t('profile.candidate.town')}</Form.Label>
                                                    <Select
                                                        className="select" 
                                                        name='town'
                                                        options={townsAux}
                                                        value={townAux || null}
                                                        onChange={(e) => handleSelectTownChange(e)}
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                    <input
                                                        tabIndex={-1}
                                                        autoComplete="off"
                                                        style={{ opacity: 0, height: 0 }}
                                                        value={formStateNewProfessional.town || ''}
                                                        required={!formStateNewProfessional.unexperienced}
                                                        readOnly
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='taughtSubjects'>{t('profile.candidate.taughtSubjects')}</Form.Label>
                                                    <Select
                                                        className="select"
                                                        onChange={handleSelectNewProfessionaltaughtSubjects}
                                                        name="taughtSubjects"
                                                        options={subjects.map(s => ({ ...s, label: t(s.label) })) || []}
                                                        value={newProfessionalTaughtSubjects}
                                                        isMulti
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                </Col>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='taughtLevels'>{t('profile.candidate.taughtLevels')}</Form.Label>
                                                    <Select
                                                        className="select"
                                                        onChange={handleSelectNewProfessionaltaughtLevels}
                                                        name="taughtLevels"
                                                        options={levels.map(s => ({ ...s, label: t('levels.'+s.label) })) || []}
                                                        value={newProfessionalTaughtLevels}
                                                        isMulti
                                                        required={!formStateNewProfessional.unexperienced}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} className='my-3'>
                                                    <Form.Label htmlFor='description'>{t('profile.candidate.descriptionwork')}</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        name='description' 
                                                        rows='3'
                                                        value={formStateNewProfessional.description ||  ''}
                                                        onChange={handleInputNewProfessional}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='start_date'>{t('profile.candidate.start_date')}</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="start_date"
                                                        value={formStateNewProfessional.start_date ||  ''}
                                                        onChange={handleInputNewProfessional}
                                                    />
                                                </Col>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='end_date'>{t('profile.candidate.end_date')}</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="end_date"
                                                        value={formStateNewProfessional.end_date ||  ''}
                                                        onChange={handleInputNewProfessional}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='contractType'>{t('profile.candidate.contractType')}</Form.Label>
                                                    <FormSelect className='form-control' name='contractType' required={!formStateNewProfessional.unexperienced} value={formStateNewProfessional.contractType || ''} onChange={handleInputNewProfessional}>
                                                        <option value="undefined">{t('profile.candidate.undefined')}</option>
                                                        <option value="practices">{t('profile.candidate.practices')}</option>
                                                        <option value="substitution">{t('profile.candidate.substitution')}</option>
                                                        <option value="temporary">{t('profile.candidate.temporary')}</option>
                                                    </FormSelect>
                                                </Col>
                                                <Col xs={12} lg={6} className='my-3'>
                                                    <Form.Label htmlFor='switch' className='m-0 me-5'>{t('profile.candidate.stillWorking')}</Form.Label>
                                                    <div className='d-flex'>
                                                        <Form.Check
                                                            className="mx-2"
                                                            type="switch"
                                                            name="switch"
                                                            id="switch"
                                                            onChange={e => setFormStateNewProfessional({...formStateNewProfessional, "stillWorking": e.target.checked, unexperienced: false})} 
                                                            checked={formStateNewProfessional.stillWorking}
                                                        />
                                                        {formStateNewProfessional.stillWorking ? t('global.yes') : t('global.no')}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className="my-3 d-flex justify-content-end">
                                                <Col xs='12' lg='4'>
                                                    <Button type="submit" className="btn-primary w-100 my-2" disabled={formStateNewProfessional.unexperienced}>{t('profile.candidate.addNewProfessional')}</Button>
                                                </Col>
                                            </Row>
                                            {
                                                    (!candidate?.professional || candidate?.professional?.length === 0) &&
                                                        <>
                                                            <Row>
                                                                <Col xs={12} lg={6} className='my-3 ms-auto text-end'>
                                                                    <Form.Label htmlFor='isUnexperienced' className='m-0'> {t('profile.candidate.isUnexperienced') }</Form.Label>
                                                                    <div className='d-flex justify-content-end'>
                                                                        <Form.Check
                                                                            className="mx-2"
                                                                            type="switch"
                                                                            name="isUnexperienced"
                                                                            id="isUnexperienced"
                                                                            onChange={e => setFormStateNewProfessional({...formStateNewProfessional, "unexperienced": e.target.checked})}
                                                                            checked={formStateNewProfessional.unexperienced}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            {
                                                                formStateNewProfessional.unexperienced
                                                                ?
                                                                    <Row className="my-3 d-flex justify-content-end">
                                                                        <Col xs='12' lg='4'>
                                                                            <Button type="submit" onClick={e => setSubmitButton('continue')} className="btn-primary w-100 my-2">{t('global.saveandcontinue')}</Button>
                                                                        </Col>
                                                                    </Row>
                                                                :
                                                                    <></>
                                                            }
                                                        </>
                                                }
                                        </Form>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}